import styled from 'styled-components';
import { space } from 'styled-system';

export const StyledContainer = styled.div(space);

export const LayoutWrapper = styled.div`
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
`;

export const ContentWrapper = styled.div`
  background: #fff;
  flex: 1;
  min-height: 0;
  margin: 0 8px;
  overflow-y: auto;
  padding-bottom: calc(60px + env(safe-area-inset-bottom));
`;
